import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { DsPill } from 'packages/design-system/ui/pill/src/pill.component';

import { ScrollSelectedInViewDirective } from '../../directives/scroll-selected-in-view/scroll-selected-in-view.directive';
import { TabBarItem } from '../../tab-bar/tab-bar.models';

@Component({
    selector: 'ms-sports-tab-bar',
    templateUrl: './sports-tab-bar.component.html',
    styleUrls: ['./sports-tab-bar.component.scss'],
    imports: [DsPill, ScrollAdapterComponent, IconCustomComponent, ScrollSelectedInViewDirective],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SportsTabBarComponent {
    @Input() sports: TabBarItem[] = [];
    @Output() selectedTab = new EventEmitter<TabBarItem>();

    get active(): TabBarItem<number> | undefined {
        return this.sports && this.sports.filter((tab) => tab.active).pop();
    }

    eventSelected(sport: TabBarItem): void {
        this.sports = this.sports.map((item) => ({
            ...item,
            active: item.id === sport.id,
        }));
        const selectedSport = this.sports.find((e) => e.id === sport.id);
        this.selectedTab.emit(selectedSport);
    }
}
